import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import React from "react";
import Button from "./Button";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const ConfirmDialog = ({
  open,
  title = "Confirm",
  content = "Are you sure you want to proceed?",
  onConfirm,
  onClose,
  confirmText = "Yes",
  cancelText = "Cancel",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
      slots={{
        transition: Transition,
      }}
      keepMounted
      // Confirm is opened from inside other modals (e.g. Approve/Reject on
      // the Payroll Details modal) - both use MUI's default Dialog z-index
      // (theme.zIndex.modal), so which one visually ends up on top isn't
      // guaranteed. Forcing this one a step higher makes sure a confirm
      // dialog always renders above whatever modal opened it, everywhere
      // useConfirm() is used, not just in Payroll.
      sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
    >
      <DialogTitle id="confirm-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-dialog-description">
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onConfirm} variant="success" autoFocus>
          {confirmText}
        </Button>
        <Button onClick={onClose} variant="light">
          {cancelText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
